import React from 'react'
import styles from './Practical.module.scss'
import icon_3 from '../../image/Portfolio/image_6.webp'
import icon_1 from '../../image/Portfolio/image_4.webp'
import icon_2 from '../../image/Portfolio/image_5.webp'
import { SliderAdvantages } from '../SliderTechnologies/SliderAdvantages'

export const Practical = () => {

    return (
        <section className={styles.main}>
            <div className={styles.container}>
                <div className={styles.box}>
                    <h2 className={styles.title} >ТЕХНОЛОГИЧНО. ПРАКТИЧНО. ДОСТУПНО</h2>
                    <div className={styles.box_image}>
                        <img className={styles.image} src={icon_1} alt='дом'/>
                        <img className={styles.image} src={icon_2} alt='дом'/>
                        <img className={styles.image} src={icon_3} alt='дом'/>
                    </div>
                    <h2 className={styles.title} >СПРОЕКТИРУЕМ И СМОНТИРУЕМ БЫСТРО</h2>
                </div>
                <SliderAdvantages/>
            </div>
        </section>
        
        
    )
}

